// tipsy, facebook style tooltips for jquery
// version 1.0.0a
// (c) 2008-2010 jason frame [jason@onehackoranother.com]
// releated under the MIT license
// MediaMath Team has done customization to meet the needs. Be Cautious while updating this plugin. 
define('jQPlugins/jquery.tipsy',['jQuery', 'Underscore', 'Backbone'], function(jQuery, _, Backbone) {
(function($) {
    
    function fixTitle($ele) {
        if ($ele.attr('title') || typeof($ele.attr('original-title')) != 'string') {
            $ele.attr('original-title', $ele.attr('title') || '').removeAttr('title');
        }
    }
    
    function Tipsy(element, options) {
        this.$element = $(element);
        this.options = options;
        this.enabled = true;
        fixTitle(this.$element);
    }
    
    Tipsy.prototype = {
        show: function() {
            var self = this,
				title,
                tipsyClass = "",
				getLeftPositionInfoForNorthSourth = function (pos, actualWidth) {
					var optionsObj = self.options,
						isLeftAligned = optionsObj.alignToOriginalEle && optionsObj.alignToOriginalEle === "left",
						isRightAligned = optionsObj.alignToOriginalEle && optionsObj.alignToOriginalEle === "right",
						leftPos;

					if (isLeftAligned === true ) {
						leftPos = pos.left;
					} else if (isRightAligned === true) {
						leftPos = (pos.left + pos.width) - actualWidth;
					} else {
						leftPos = pos.left + pos.width / 2 - actualWidth / 2;
					}

					return {
						isLeftAligned: isLeftAligned,
						isRightAligned: isRightAligned,
						leftPos: leftPos
					}
				};
                
             if (this.options.getExternalTip) {
                this.options.html = true;
                title = $("." + this.$element.data("tip-content")).html();
                tipsyClass = this.options.className || "";
             } else {
                title = this.getTitle();
             }

            if (title && this.enabled) {
                var $tip = this.tip();
                
                $tip.find('.tipsy-inner')[this.options.html ? 'html' : 'text'](title);
                $tip[0].className = 'tipsy'; // reset classname in case of dynamic gravity
                $tip.remove().css({top: 0, left: 0, visibility: 'hidden', display: 'block'}).appendTo(document.body);
                $tip.addClass(tipsyClass);

                var pos = $.extend({}, this.$element.offset(), {
                    width: this.$element[0].offsetWidth,
                    height: this.$element[0].offsetHeight
                });

                if (typeof this.$element[0].nearestViewportElement == 'object') {
                    // SVG
					var el = this.$element[0];
                    var rect = el.getBoundingClientRect();
					pos.width = rect.width;
					pos.height = rect.height;
                }

                
                var actualWidth = $tip[0].offsetWidth, actualHeight = $tip[0].offsetHeight;
                var gravity = (typeof this.options.gravity == 'function')
                                ? this.options.gravity.call(this.$element[0])
                                : this.options.gravity;

                var tp;

				//wku:july-15-2012: added alignToOriginalEle option per Holly for agency tip. now supports both 'left' and 'right' alignments
				var posInfo = getLeftPositionInfoForNorthSourth(pos, actualWidth);

                switch (gravity.charAt(0)) {
                    case 'n':
                        tp = {top: pos.top + pos.height + this.options.offset, left: posInfo.leftPos};
                        break;
                    case 's':
						tp = {top: pos.top - actualHeight - this.options.offset, left: posInfo.leftPos};
                        break;
                    case 'e':
                        tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth - this.options.offset};
                        break;
                    case 'w':
                        tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width + this.options.offset};
                        break;
                }
                
                if (gravity.length == 2 && posInfo.isLeftAligned !== true && posInfo.isRightAligned !== true) {
                    if (gravity.charAt(1) == 'w') {
						tp.left = pos.left + pos.width / 2 - 15;
                    } else {
                        tp.left = pos.left + pos.width / 2 - actualWidth + 15;
                    }
                }

				if (this.options.leftPosAdjust && isNaN(this.options.leftPosAdjust) === false) {
					tp.left = tp.left + parseInt(this.options.leftPosAdjust);
				}
                
                $tip.css(tp).addClass('tipsy-' + gravity);
                $tip.find('.tipsy-arrow')[0].className = 'tipsy-arrow tipsy-arrow-' + gravity.charAt(0);
                if (this.options.className) {
                    $tip.addClass(this.options.className);
                }
                
                if (this.options.fade) {
                    $tip.stop().css({opacity: 0, display: 'block', visibility: 'visible'}).animate({opacity: this.options.opacity});
                } else {
                    $tip.css({visibility: 'visible', opacity: this.options.opacity});
                }
            }
        //XXX: SHOW FUNCTION UPDATED SO SCROLL EVENTS ARE ONLY MONITORED WHEN TOOLTIP IS VISIBLE
        //Lance Massey
        //June 28, 2012
            $(window).bind('scroll', {tip: this}, this.hide);
        },
        
        //XXX: HIDE FUNCTION UPDATED SO SCROLL EVENTS ARE ONLY MONITORED WHEN TOOLTIP IS VISIBLE
        //Lance Massey
        //June 28, 2012
        hide: function(e) {
        	var tipper; 
        	if(!(this instanceof Tipsy)){
        		tipper = e.data.tip;
        	}else {
        		tipper = this
        	}
            if (tipper.options.fade) {
                tipper.tip().stop().fadeOut(function() { $(tipper).remove(); });
            } else {
                tipper.tip().remove();
            }
            $(window).unbind('scroll', tipper.hide);
        },
        
        getTitle: function() {
            var title, $e = this.$element, o = this.options;
            fixTitle($e);
            var title, o = this.options;
            if (typeof o.title == 'string') {
                title = $e.attr(o.title == 'title' ? 'original-title' : o.title);
            } else if (typeof o.title == 'function') {
                title = o.title.call($e[0]);
            }
            title = ('' + title).replace(/(^\s*|\s*$)/, "");
            return title || o.fallback;
        },
        
        tip: function() {
            if (!this.$tip) {
                this.$tip = $('<div class="tipsy"></div>').html('<div class="tipsy-inner"></div><div class="tipsy-arrow-c"><div class="tipsy-arrow"></div></div>');
            }
            return this.$tip;
        },
        
        validate: function() {
            if (!this.$element[0].parentNode) {
                this.hide();
                this.$element = null;
                this.options = null;
            }
        },
        
        enable: function() { this.enabled = true; },
        disable: function() { this.enabled = false; },
        toggleEnabled: function() { this.enabled = !this.enabled; }
    };
    
    $.fn.tipsy = function(options) {
        
        if (options === true) {
            return this.data('tipsy');
        } else if (typeof options == 'string') {
            return this.data('tipsy')[options]();
        }
        
        options = $.extend({}, $.fn.tipsy.defaults, options);
        
        function get(ele) {
            var tipsy = $.data(ele, 'tipsy');
            if (!tipsy) {
                tipsy = new Tipsy(ele, $.fn.tipsy.elementOptions(ele, options));
                $.data(ele, 'tipsy', tipsy);
            }
            return tipsy;
        }
        
        function enter() {
            var tipsy = get(this);
            tipsy.hoverState = 'in';
            if (options.delayIn == 0) {
                tipsy.show();
            } else {
                setTimeout(function() { if (tipsy.hoverState == 'in') tipsy.show(); }, options.delayIn);
            }
        }
        
        function leave() {
            var tipsy = get(this);
            tipsy.hoverState = 'out';
            if (options.delayOut == 0) {
                tipsy.hide();
            } else {
                setTimeout(function() { if (tipsy.hoverState == 'out') tipsy.hide(); }, options.delayOut);
            }
        }
        
        if (!options.live) this.each(function() { get(this); });
        
        if (options.trigger != 'manual') {
        	//XXX: HAD TO CHANGE mouseenter AND mouseleave TO mouseover AND mouseout SO THAT IE9 WOULD SHOW TOOL TIPS IN THE CHART
        	//CHANGE MADE: June 13, 2012
        	//Lance Massey
            var binder   = options.live ? 'live' : 'bind',
                eventIn  = options.trigger == 'hover' ? 'mouseover' : 'focus',
                eventOut = options.trigger == 'hover' ? 'mouseout' : 'blur';
            this[binder](eventIn, enter)[binder](eventOut, leave);
		}

        return this;
    };
    
    $.fn.tipsy.defaults = {
        className: null,
        delayIn: 0,
        delayOut: 0,
        fade: false,
        fallback: '',
        gravity: 'n',
        html: false,
        live: false,
        offset: 0,
        opacity: 0.8,
        title: 'title',
        trigger: 'hover'
    };
    
    // Overwrite this method to provide options on a per-element basis.
    // For example, you could store the gravity in a 'tipsy-gravity' attribute:
    // return $.extend({}, options, {gravity: $(ele).attr('tipsy-gravity') || 'n' });
    // (remember - do not modify 'options' in place!)
    $.fn.tipsy.elementOptions = function(ele, options) {
        return $.metadata ? $.extend({}, options, $(ele).metadata()) : options;
    };
    
    $.fn.tipsy.autoNS = function() {
        return $(this).offset().top > ($(document).scrollTop() + $(window).height() / 2) ? 's' : 'n';
    };
    
    $.fn.tipsy.autoWE = function() {
        return $(this).offset().left > ($(document).scrollLeft() + $(window).width() / 2) ? 'e' : 'w';
    };

})(jQuery);
});
